import { Link } from "@tanstack/react-router";
import { practiceAreas } from "@/data/practice-areas";
import { services } from "@/data/services";
import { locations } from "@/data/locations";
import { ukMenuItems } from "@/data/uk-pages";

export function Footer({ linkSeoDescription = false }: { linkSeoDescription?: boolean }) {
  return (
    <footer className="bg-[var(--navy-deep)] text-primary-foreground mt-16 sm:mt-24">
      <div className="mx-auto max-w-7xl px-5 py-12 grid grid-cols-2 gap-8 sm:px-6 md:grid-cols-4 md:gap-10 md:py-16">
        <div className="col-span-2 md:col-span-1">
          <div className="flex items-center gap-2 mb-4">
            <span className="inline-flex h-9 w-9 items-center justify-center rounded-md bg-gold-gradient text-[var(--navy-deep)] font-display font-bold">P1</span>
            <span className="font-display text-lg font-semibold">PageOne Lawyers</span>
          </div>
          <p className="text-sm text-primary-foreground/70 leading-relaxed">
            The SEO company built exclusively for law firms. Ethical, transparent, results-driven.
          </p>
        </div>
        <div>
          <h4 className="text-sm font-semibold mb-4 text-[var(--gold)]">Services</h4>
          <ul className="space-y-2 text-sm text-primary-foreground/75">
            {services.slice(0, 8).map((s) => (
              <li key={s.slug}><Link to="/services/$slug" params={{ slug: s.slug }} className="hover:text-[var(--gold)]">{s.name}</Link></li>
            ))}
          </ul>
          <h5 className="mt-5 mb-2 text-xs font-semibold uppercase tracking-wider text-[var(--gold)]">For UK firms</h5>
          <ul className="space-y-2 text-sm text-primary-foreground/75">
            {ukMenuItems.map((u) => (
              <li key={u.href}><a href={u.href} className="hover:text-[var(--gold)]">{u.title}</a></li>
            ))}
          </ul>
        </div>
        <div>
          <h4 className="text-sm font-semibold mb-4 text-[var(--gold)]">Practice Areas</h4>
          <ul className="space-y-2 text-sm text-primary-foreground/75">
            {practiceAreas.slice(0, 8).map((p) => (
              <li key={p.slug}><Link to="/practice-areas/$slug" params={{ slug: p.slug }} className="hover:text-[var(--gold)]">{p.shortName}</Link></li>
            ))}
          </ul>
        </div>
        <div>
          <h4 className="text-sm font-semibold mb-4 text-[var(--gold)]">Company</h4>
          <ul className="space-y-2 text-sm text-primary-foreground/75">
            <li><Link to="/about" className="hover:text-[var(--gold)]">About</Link></li>
            <li><Link to="/case-studies" className="hover:text-[var(--gold)]">Case Studies</Link></li>
            <li><Link to="/pricing" className="hover:text-[var(--gold)]">Pricing</Link></li>
            <li><Link to="/blog" className="hover:text-[var(--gold)]">Blog</Link></li>
            <li><Link to="/glossary" className="hover:text-[var(--gold)]">Glossary</Link></li>
            <li><Link to="/lawyer-seo" className="hover:text-[var(--gold)]">Locations</Link></li>
            <li><Link to="/law-firm-seo-audit" className="hover:text-[var(--gold)]">Free SEO Audit</Link></li>
            <li><Link to="/contact" className="hover:text-[var(--gold)]">Contact</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
         <div className="mx-auto max-w-7xl px-5 py-10 sm:px-6">
          <h4 className="text-sm font-semibold mb-4 text-[var(--gold)]">Lawyer SEO by city & state</h4>
          <div className="flex flex-wrap gap-x-4 gap-y-2 text-sm text-primary-foreground/70">
            {locations.slice(0, 36).map((l) => (
              <Link key={l.slug} to="/lawyer-seo/$slug" params={{ slug: l.slug }} className="hover:text-[var(--gold)]">{l.location}</Link>
            ))}
            <Link to="/lawyer-seo" className="font-semibold text-[var(--gold)]">View all →</Link>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="mx-auto max-w-7xl px-5 py-6 flex flex-col gap-2 sm:px-6 md:flex-row md:justify-between text-xs text-primary-foreground/60">
          <p>© {new Date().getFullYear()} PageOne Lawyers. {linkSeoDescription ? <Link to="/services/law-firm-seo">SEO services for attorneys</Link> : "SEO services for attorneys"}. Not legal advice.</p>
          <p>Built with ethical SEO. No PBNs. No spam. No nonsense.</p>
        </div>
      </div>
    </footer>
  );
}